import { gsap } from "gsap/dist/gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// import { ScrollSmoother } from "./scrollSmoother.min.js";

gsap.registerPlugin(ScrollTrigger);

let screenMobile = window.matchMedia("(max-width: 576px)"),
  screenTablet = window.matchMedia("(max-width: 1200px)");

class Animations {
  constructor() {
    this.swipe();
    this.shift();
    this.zoom();
    this.bgshift();
    this.loadshift();
    this.enterShift();
  }

  swipe() {
    const i = document.querySelectorAll(".animate.swipe .mask").length;
    if (!i) return;
    gsap.set(".animate.swipe .mask ", {
      opacity: "0",
      y: 20,
    });

    let shift = screenMobile.matches ? 5 : 20;

    document.querySelectorAll(".animate.swipe .mask").forEach(function (item) {
      gsap.fromTo(
        item,
        {
          opacity: "0",
          y: shift,
        },
        {
          duration: 1,
          opacity: "1",
          y: 0,
          ease: "power2.out",
          scrollTrigger: {
            ease: "power2.out",
            start: "top 80%",
            end: "top 70%",
            scrub: true,
            trigger: item,
          },
        }
      );
    });
  }

  shift() {
    const i = document.querySelectorAll(".animate.shift .shift").length;
    if (!i || screenMobile.matches) return;

    document.querySelectorAll(".animate.shift .shift").forEach((item) => {
      const speed = item.dataset.speed;
      const offsetRate = item.dataset.offset;
      // const movement = -ScrollTrigger.maxScroll(window) * speed;
      let offset = screenTablet.matches ? 100 : 100;

      gsap.set(item, {
        y: offset * offsetRate,
      });

      gsap.to(item, {
        y: 0,
        ease: "none",
        scrollTrigger: {
          trigger: item.parentNode,
          start: "top bottom",
          end: "bottom 66%",
          scrub: true,
        },
      });
    });
  }

  zoom() {
    const i = document.querySelectorAll(".animate.zoom").length;
    if (!i) return;

    gsap.set(".animate.zoom", {
      scale: "1",
    });

    document
      .querySelectorAll(
        ".animate.zoom"
      )
      .forEach((item) => {
        gsap.to(item, {
          scale: 1.1,
          ease: "none",
          scrollTrigger: {
            trigger: item,
            start: item.closest('.zoom--above-fold') ? 0 : "top center",
            end: "bottom top",
            scrub: true,
          },
        });
      });
  }

  bgshift() {
    const i = document.querySelectorAll(".animate.shift .bg-shift").length;
    if (!i) return;

    gsap.set(".animate.shift .shifting img", {
      yPercent: "-10",
    });

    gsap.set(".animate.shift .bg-shift:not(.bg-shift--above-fold) img", {
      yPercent: "-10",
      scale: "1.1",
    });

    document
      .querySelectorAll(
        ".animate.shift .bg-shift img, .animate.shift .shifting img"
      )
      .forEach((item) => {
        gsap.to(item, {
          yPercent: "10",
          ease: "none",
          scrollTrigger: {
            trigger: item,
            start: item.closest('.bg-shift--above-fold') ? 0 : "top bottom",
            end: "bottom top",
            scrub: true,
          },
        });
      });
  }

  loadshift() {
    const i = document.querySelectorAll(".animate.shift .shift-up").length;
    if (!i) return;

    let start = screenMobile.matches ? "top 50%" : "top 80%",
      end = screenMobile.matches ? "top 45%" : "top 70%",
      shift = screenMobile.matches ? "5" : "20";

    gsap.set(".animate.shift .shift-up", {
      y: shift,
      opacity: 0,
    });

    document
      .querySelectorAll(".animate.shift .shift-up")

      .forEach((item) => {
        gsap.to(item, {
          duration: 1,
          opacity: 1,
          y: 0,
          stagger: { each: 0.15 },
          overwrite: true,
        });
      });
  }

  enterShift() {
    const i = document.querySelectorAll(".animate.enter-shift").length;
    if (!i) return;

    let shift = screenMobile.matches ? "20" : "40";

    gsap.set(".animate.enter-shift", {
      y: shift,
      opacity: 0,
    });

    const timelines = new Map();

    document.querySelectorAll(".animate.enter-shift").forEach((item) => {
      const section = item.closest(".shopify-section");
      if (!timelines.has(section)) {
        timelines.set(
          section,
          gsap.timeline({
            duration: 0.5,
            scrollTrigger: {
              trigger: section,
              start: "top 50%",
            },
          })
        );
      }

      const timeline = timelines.get(section);

      timeline.to(
        item,
        {
          opacity: 1,
          y: 0,
        },
        "<0.1"
      );
    });
  }

  refresh(animation) {
    this[animation]();
  }
}

const animations = new Animations();
export default animations;
